import React, { useEffect, useState } from "react";
import { api } from "../../api";
import AdminSubNav from "./AdminSubNav";

function formatDate(iso) {
  try {
    return new Date(iso.replace(" ", "T") + "Z").toLocaleString();
  } catch {
    return iso;
  }
}

export default function AdminIssuesPage() {
  const [issues, setIssues] = useState(null);
  const [error, setError] = useState("");

  const load = () =>
    api.get("/api/admin/issues").then((d) => setIssues(d.issues)).catch((e) => setError(e.message));

  useEffect(() => {
    load();
  }, []);

  const toggleStatus = async (issue) => {
    const nextStatus = issue.status === "open" ? "resolved" : "open";
    try {
      await api.put(`/api/admin/issues/${issue.id}/status`, { status: nextStatus });
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="page">
      <h1>Admin</h1>
      <AdminSubNav active="issues" />
      <p className="muted">Issues submitted through the site-wide "Report an issue" button.</p>
      {error && <div className="alert alert-error">{error}</div>}

      <table className="admin-table">
        <thead>
          <tr>
            <th>Status</th>
            <th>Reported by</th>
            <th>Description</th>
            <th>Page</th>
            <th>Received</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {issues && issues.length === 0 && (
            <tr>
              <td colSpan={6} className="muted">
                No issues reported yet.
              </td>
            </tr>
          )}
          {issues &&
            issues.map((issue) => (
              <tr key={issue.id}>
                <td>
                  <span className={`badge ${issue.status === "open" ? "badge-warning" : "badge-success"}`}>
                    {issue.status === "open" ? "Open" : "Resolved"}
                  </span>
                </td>
                <td>
                  <div>{issue.user_name || "Anonymous"}</div>
                  <div className="muted" style={{ fontSize: 12 }}>
                    {issue.email || "—"}
                  </div>
                </td>
                <td style={{ maxWidth: 380, whiteSpace: "pre-wrap" }}>{issue.description}</td>
                <td className="muted" style={{ fontSize: 12, maxWidth: 200, wordBreak: "break-all" }}>
                  {issue.page_url || "—"}
                </td>
                <td className="muted" style={{ fontSize: 13 }}>
                  {formatDate(issue.created_at)}
                </td>
                <td>
                  <button className="btn btn-ghost btn-sm" onClick={() => toggleStatus(issue)}>
                    Mark {issue.status === "open" ? "resolved" : "open"}
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}
